module.exports = __webpack_public_path__ + "img/20.bd21d301.jpg";